import { Paper } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { IEntityContentField } from '../../../../lib/interfaces/Common';
import ContentTitleWithIcon from '../../../Simple/ContentTitle/ContentTitleWithIcon';
import ContentRenderer from '../../Content/ContentRenderer';

import './Overview.scss';

type OverviewProps = {
	field: IEntityContentField;
};

const Overview: FC<OverviewProps> = ({ field }) => {
	const { t } = useTranslation();
	const title = field.options?.label || t('taskOverview');
	return (
		<div className="Overview">
			<Paper variant="outlined" sx={{ padding: '10px' }} className="wrapper">
				<ContentTitleWithIcon content={title} icon={SummarizeIcon} id={field.id} />
				<ContentRenderer html={field.content} key={field.name} />
			</Paper>
		</div>
	);
};

export default Overview;
